export default {
  'open-menu': 'Abrir el menú',
  'close-menu': 'Cerrar',
  'editorial-staff': 'Redacción',
  about: 'Estos somos nosotros',
  shopLink: 'Un mundo de posibilidades',
}
